import React from 'react';
import { Col, Row } from 'reactstrap';
import { CommonHeadFooter, OriginalPrice, ProdCardDesc, ProdCardName } from '../../../StyledComponents';
import { Star } from 'react-feather';


const RecentlyViewed = (props) => {
  const { products } = props

  return (
    <div className='mb-3'>
      <div className='w-100'>
        <Row className='m-0 overflow-auto flex-nowrap'>
          {products.map((product) => (
            <Col key={product.id} xl='2' lg='4' sm='6' style={{ height: 'auto' }}>
              <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <img style={{ maxWidth: "100%", width: "227px", margin: "0 auto" }} src={product.image} alt={product.name} />
                <div style={{ margin: "8px auto 0 auto", height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <ProdCardName>{product.name}</ProdCardName>
                  <div style={{ width: '100%', padding: '8px 0 8px 0', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center' }}>
                      <CommonHeadFooter style={{ color: 'orange', margin: '0' }}>${product.price}</CommonHeadFooter> &nbsp;
                      <OriginalPrice><strike>${product.originalPrice}</strike></OriginalPrice>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center' }}>
                      <div><Star size={12} color="orange" fill='orange' style={{ marginBottom: '6px' }} /></div> &nbsp;
                      <OriginalPrice>{product.rating} ({product.reviews})</OriginalPrice>
                    </div>
                  </div>
                  <ProdCardDesc>{product.description}</ProdCardDesc>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default RecentlyViewed;